import React from 'react';
import classnames from 'classnames';
import Icon from '../../../../../components/icon/Icon';
import { languageWithoutRegionCode } from '../../../../../locales/configure';
import { useDropdownFeature } from '../../../../../utils/hooks/useOutsideClickEffect';
import { t } from '../../../../../utils/translate';
import translations from './LanguageSelector.translations';

import './LanguageSelector.scss';

const LanguageSelector = () => {
  function handleChange(value) {
    if (typeof window.localStorage === 'object') {
      window.localStorage.setItem('language', value);
    }
    window.location.reload();
  }
  function chooseFR() {
    handleChange('fr');
  }
  function chooseEN() {
    handleChange('en');
  }
  const items = [
    { value: 'fr', handler: chooseFR, label: t(translations.frLanguage) },
    { value: 'en', handler: chooseEN, label: t(translations.enLanguage) },
  ];
  function display(lang) {
    const item = items
      .find(({ value }) => value === lang);
    if (!item) {
      return t(translations.frLanguage);
    }
    return item.label;
  }
  const [ref, toggle,, { isActive }] = useDropdownFeature();
  return (
    <div
      ref={ref}
      className={classnames('language-selector', {
        'language-selector-opened': isActive,
      })}
    >
      <button
        type="button"
        className="language-selector-toggle"
        onClick={toggle}
      >
        {display(languageWithoutRegionCode)}
        <Icon name="caret-thin" />
      </button>

      {isActive && (
        <ul className="language-selector-dropdown">
          {items.map(({ handler, label }) => (
            <li
              key={label}
              className="language-selector-option"
            >
              <button
                type="button"
                onClick={handler}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
